import { helpers } from "vuelidate/lib/validators";

const regex =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i;

export const validURL = helpers.regex("validURL", regex);
